import { ChangeEvent, useState } from "react";

interface FileUploaderProps {
  file: File | null;
  setFile: (file : File) => void;
  setImageURL: (imageURL: string) => void;
}

export default function FileUploader({ file, setFile, setImageURL } : FileUploaderProps){
    const [fileName, setFileName] = useState<string | null>(null);

    function handleFileChange(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.files) {
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);
            setImageURL(URL.createObjectURL(e.target.files[0]));
        }
    }

    return (
    <div className="file-input-wrapper">
      <label className="file-input-label">
        Bild auswählen
        <input
          type="file"
          accept="image/*"
          className="file-input-hidden"
          onChange={handleFileChange}
        />
      </label>
      {fileName && <span className="file-input-filename">{fileName}</span>}
    </div>
    );
}